import { render } from "./viewinfo.vue?vue&type=template&id=d528862e"
import script from "./viewinfo.vue?vue&type=script&lang=js"
export * from "./viewinfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__